__turbopack_context__.v({
  "iconSlot": "ButtonV2-module__MUKeGG__iconSlot",
  "label": "ButtonV2-module__MUKeGG__label",
  "styledCta": "ButtonV2-module__MUKeGG__styledCta" + " " + __turbopack_context__.i(931616)["ctaStyle"],
});
